import React from 'react'
import ReactDOM from 'react-dom'
import styled, { css } from 'styled-components'
import { RowFlexDiv } from './CommonStyle'
import { Icon } from './CommonStyle'

const trackH = '0.2em'
const thumbD = '1em'
const trackC = '#ccced0'
const filllC = '#6A02FD'

const track = css`
  box-sizing: border-box;
  border: none;
  height: 2px;
  background: ${trackC};
  border-radius: 8px;
`

const trackFill = css`
  ${track};
  height: 2px;
  background-color: transparent;
  background-image: linear-gradient(${filllC}, ${filllC}),
    linear-gradient(${trackC}, ${trackC});
  background-size: var(--sx) 6px, calc(100% - var(--sx)) 4px;
  background-position: left center, right center;
  background-repeat: no-repeat;
`

const fill = css`
  height: ${trackH};
  background: ${filllC};

  border-radius: 4px;
`

const thumb = css`
  box-sizing: border-box;
  border: none;
  width: ${thumbD};
  height: ${thumbD};
  border-radius: 50%;
  background: #6a02fd;
  box-shadow: 0px 0px 5px rgba(66, 97, 255, 0.5);
`

const Input = styled.input`
  &,
  &::-webkit-slider-thumb {
    -webkit-appearance: none;
  }

  &:focus {
    outline: none;
  }

  /* &:focus::-webkit-slider-thumb {
    outline: -webkit-focus-ring-color auto 5px;
  } */

  &:focus::-moz-range-thumb {
    outline: -webkit-focus-ring-color auto 5px;
  }

  &:focus::-ms-thumb {
    outline: -webkit-focus-ring-color auto 5px;
  }

  --range: calc(var(--max) - var(--min));
  --ratio: calc((var(--val) - var(--min)) / var(--range));
  --sx: calc(0.5 * ${thumbD} + var(--ratio) * (100% - ${thumbD}));

  margin: 0;
  padding: 0;
  margin-top: 10px;
  height: ${thumbD};
  background: transparent;
  font: 1em/1 arial, sans-serif;

  &::-webkit-slider-runnable-track {
    ${trackFill};
  }

  &::-moz-range-track {
    ${track};
  }

  &::-ms-track {
    ${track};
  }

  &::-moz-range-progress {
    ${fill};
  }

  &::-ms-fill-lower {
    ${fill};
  }

  &::-webkit-slider-thumb {
    margin-top: calc(0.5 * (${trackH} - ${thumbD}));
    ${thumb};
  }

  &::-moz-range-thumb {
    ${thumb};
  }

  &::-ms-thumb {
    margin-top: 0;
    ${thumb};
  }

  &::-ms-tooltip {
    display: none;
  }

  &::-moz-focus-outer {
    border: 0;
  }
`

const Slider = ({ zoomView, setZoomView }) => {
  const [value, setValue] = React.useState(0)

  function handleUpdate(e) {
    if (e.target.name === 'zoom in') {
      setValue(100)

      if (zoomView === false) {
        setZoomView(true)
      }

      console.log('zoom in clicked')
    } else if (e.target.name === 'zoom out') {
      console.log('zoom out clicked')
      setValue(0)

      if (zoomView === true) {
        setZoomView(false)
      }
    } else {
      // inputView
      console.log(e.target.value)

      if (e.target.value > 50) {
        if (zoomView == false) {
          setZoomView(true)
        }
      } else {
        if (zoomView == true) {
          setZoomView(false)
        }
      }
    }
  }
  return (
    <RowFlexDiv
      width='100%'
      gap='5px'
      justifyContent='center'
      alignItems='center'
      // backgroundColor='#456789'
    >
      <Icon
        src='/images/mainView/assignmentsView/zoom-out.svg'
        name='zoom out'
        onClick={handleUpdate}
      />

      <Input
        onInput={(e) => setValue(e.target.value)}
        onMouseUpCapture={handleUpdate}
        type='range'
        value={value}
        style={{
          width: '100%',
          '--min': 0,
          '--max': 100,
          '--step': 25,
          '--val': value,
          alignItems: 'flex-start',
          justifyContent: 'flex-start',
        }}
      ></Input>
      <Icon
        src='/images/mainView/assignmentsView/zoom-in.svg'
        name='zoom in'
        onClick={handleUpdate}
      />
    </RowFlexDiv>
  )
}

export default Slider
